/**
 * Badge manual vs auto nos cards de participantes.
 *
 * - Com `__meta_auto__` na planilha: contagem do registro do envio (exato).
 * - Sem meta: presume 100% manual (padrão do bolão — maioria preencheu à mão).
 * - Meta mista "sobrescreve" (manual e auto): oculta — dado antigo não confiável.
 */
import { contarPalpitesGruposValidos, type PlacaresMap } from './copaCalculo';
import {
  META_VAZIA,
  extrairMetaDosPalpites,
  type MetaPreenchimento,
} from './copaMetaPreenchimento';

export interface ContagemAutoManual {
  total: number;
  manual: number;
  auto: number;
  /** exato = meta na planilha; presumido = sem registro de auto no envio */
  certeza: 'exato' | 'presumido';
  meta: MetaPreenchimento;
}

export function calcularContagemAutoManual(
  palpites: PlacaresMap | undefined | null
): ContagemAutoManual | null {
  if (!palpites) return null;
  const total = contarPalpitesGruposValidos(palpites);
  if (total === 0) return null;

  const meta = extrairMetaDosPalpites(palpites);

  if (meta.autoUsado !== 'sobrescreve' && meta.autoUsado !== 'somente-vazios') {
    return {
      total,
      manual: total,
      auto: 0,
      certeza: 'presumido',
      meta: { ...META_VAZIA },
    };
  }

  const manual = Math.min(total, Math.max(0, meta.qtdManualAposAuto));
  const auto = total - manual;

  if (manual > 0 && auto > 0 && meta.autoUsado === 'sobrescreve') {
    return null;
  }

  return {
    total,
    manual,
    auto,
    certeza: 'exato',
    meta,
  };
}

export function rotuloContagem(c: ContagemAutoManual): string {
  if (c.auto === 0) return `${c.total} manual`;
  if (c.manual === 0) return `${c.total} auto`;
  return `${c.manual} manual · ${c.auto} auto`;
}

export function tituloContagem(c: ContagemAutoManual): string {
  if (c.certeza === 'presumido') {
    return `${c.total} jogo(s) preenchido(s) manualmente (sem registro de auto-preencher no envio).`;
  }
  return `Registro do envio: ${c.manual} jogo(s) manual(is), ${c.auto} pelo auto-preencher.`;
}
